
const iframeElement = document.querySelector('.js-gosee--campervan-frame');

let selectors = null;
let formContainer = null;

//let externalScript = null
let isInitializing = false;
let heightCheckInterval = null;

const campervan = {

	init: function () {
		if (iframeElement) {

			window.addEventListener('message', function (event) {
				// Check the origin for security:
				if (event.origin !== window.location.origin) {
					console.log('Message from untrusted origin:', {
						origin: event.origin,
						location: window.location.origin
					});
					return;
				}

				if (event?.data?.height) {
					iframeElement.style.height = event.data.height + "px";
				}

				// Handle form submission event from iframe
				if (event?.data?.type === 'motorhomeSubmission' && event?.data?.formData) {
					campervan._handleFormSubmission(event.data.formData);
				}
			});
		}

		formContainer = document.querySelector('.js-gosee--campervan');
		if (formContainer) {
			campervan._initForm();

			if (window.ResizeObserver && formContainer) {
				let lastHeight = 0;

				const calculateHeight = () => {
					// Check for open select2 dropdowns which might affect height
					const openDropdowns = document.querySelectorAll('.select2-container--open, .select2-dropdown--below, .select2-dropdown--above');
					const hasOpenDropdown = openDropdowns.length > 0;

					// Calculate height from multiple sources
					const bodyScrollHeight = document.body.scrollHeight;
					const bodyOffsetHeight = document.body.offsetHeight;
					const documentHeight = document.documentElement.scrollHeight;
					const formHeight = formContainer.scrollHeight;
					const formOffsetHeight = formContainer.offsetHeight;

					// Get the bounding rect which gives actual rendered dimensions
					const formRect = formContainer.getBoundingClientRect();
					const formBoundingHeight = Math.ceil(formRect.bottom - formRect.top);

					// Calculate content height without dropdown influence if dropdown is closed
					let contentHeight;
					if (!hasOpenDropdown) {
						// When dropdown is closed, use the smaller of measurements to allow shrinking
						contentHeight = Math.max(
							formHeight,
							formOffsetHeight,
							formBoundingHeight,
							337 // Minimum height
						);
					} else {
						// When dropdown is open, include body/document measurements
						contentHeight = Math.max(
							bodyScrollHeight,
							bodyOffsetHeight,
							documentHeight,
							formHeight,
							formOffsetHeight,
							formBoundingHeight,
							300 // Minimum height
						);
					}

					return contentHeight;
				};

				const updateHeight = () => {
					// Wait a brief moment for any dropdown animations to complete
					setTimeout(() => {
						const height = calculateHeight();

						// Only send message if height has changed
						if (height !== lastHeight) {
							const messageData = { height };
							window.parent.postMessage(messageData, '*');
							lastHeight = height;
						}
					}, 50);
				};

				const resizeObserver = new ResizeObserver(updateHeight);
				resizeObserver.observe(formContainer);

				// Also observe body for dropdown changes
				const bodyObserver = new ResizeObserver(updateHeight);
				bodyObserver.observe(document.body);

				// Listen for Select2 events using vanilla JavaScript
				// Select2 events bubble up from the select elements
				formContainer.addEventListener('select2:open', function() {
					console.log('Select2 dropdown opened');
					updateHeight();
				});

				formContainer.addEventListener('select2:close', function() {
					console.log('Select2 dropdown closed');
					// Multiple checks to ensure height adjusts after dropdown closes
					updateHeight();
					setTimeout(updateHeight, 100);
					setTimeout(updateHeight, 300);
				});

				// Add MutationObserver to watch for dropdown class changes
				const mutationObserver = new MutationObserver(() => {
					updateHeight();
				});

				mutationObserver.observe(document.body, {
					attributes: true,
					attributeFilter: ['class'],
					subtree: true
				});

				// Periodic check as fallback (every 500ms)
				setInterval(() => {
					const currentDropdownState = document.querySelectorAll('.select2-container--open').length > 0;
					const previousDropdownState = lastHeight > 400; // Rough estimate

					if (currentDropdownState !== previousDropdownState) {
						updateHeight();
					}
				}, 500);
			}
		}
	},

	_initForm: function () {

		const checkFormReady = (attempts = 0) => {

			selectors = {
				locationSectionCamper: formContainer?.getElementsByClassName('republic-section-locations')[0],
				dateSectionCamper: formContainer?.getElementsByClassName('republic-section-dates')[0],
				driverSectionCamper: formContainer?.getElementsByClassName('republic-section-driver')[0],
				buttonSectionCamper: formContainer?.getElementsByClassName('republic-section-button')[0]
			};

			if (
				selectors.locationSectionCamper
				&& selectors.dateSectionCamper
				&& selectors.driverSectionCamper
				&& selectors.buttonSectionCamper
			) {
				campervan._initFormManipulate();
			} else if (attempts < 50) {
				setTimeout(() => checkFormReady(attempts + 1), 200);
			} else {
				isInitializing = false;
			}
		};

		checkFormReady();
	},

	_initFormManipulate: function () {

		campervan._reFrameLocationsCamper();
		campervan._reFrameDriverAndAgeCamper();
		campervan._updateButtonTextCamper();
		campervan._updateLocationLabelsCamper();
		campervan._updateDateLabelsCamper();
		campervan._updateNationalityLabelCamper();
		campervan._showForm();

		isInitializing = false;
	},

	_reFrameLocationsCamper: function () {

		var locationCheckBox = formContainer.getElementsByClassName('republic-switch-row')[0];

		if (locationCheckBox) {
			locationCheckBox.style.display = 'none';
		}

		var locationCheckBoxTwo = formContainer.getElementsByClassName('republic-switch-row')[1];

		if (locationCheckBoxTwo) {
			locationCheckBoxTwo.style.display = 'none';
		}

		var element = selectors.locationSectionCamper.getElementsByClassName('republic-field')[1];
		var element2 = selectors.locationSectionCamper.getElementsByClassName('republic-field')[2];
		var parent = element.parentNode;
		var wrapper = document.createElement('div');

		wrapper.className = 'republic-wrapper';
		parent.replaceChild(wrapper, element);
		wrapper.appendChild(element);

		if (element2) {
			wrapper.appendChild(element2);
		}
	},

	_reFrameDriverAndAgeCamper: function () {
		var driverCheckBox = selectors.driverSectionCamper.getElementsByClassName('republic-row')[1];
		var driverAndAge = selectors.driverSectionCamper.getElementsByClassName('republic-row')[2];

		if (driverAndAge) {
			driverAndAge.classList.remove('republic-hide');
		}
		if (driverCheckBox) {
			driverCheckBox.classList.remove('republic-hide');
		}
	},

	_updateButtonTextCamper: function () {
		selectors.buttonSectionCamper.getElementsByTagName('span')[0].innerHTML = 'FIND A CAMPERVAN';
		selectors.buttonSectionCamper.getElementsByTagName('span')[0].onclick = campervan._datatag;
	},

	_updateLocationLabelsCamper: function () {
		let pickupLabel = selectors.locationSectionCamper.getElementsByClassName('republic-label')[1];
		let returnLabel = selectors.locationSectionCamper.getElementsByClassName('republic-label')[2];

		pickupLabel.innerHTML = "Pick Up Location";
		returnLabel.innerHTML = "Return Location";
	},

	_updateDateLabelsCamper: function () {
		let pickupLabel = selectors.dateSectionCamper.getElementsByClassName('republic-label')[0];
		let returnLabel = selectors.dateSectionCamper.getElementsByClassName('republic-label')[1];

		pickupLabel.innerHTML = "Pick Up Date";
		returnLabel.innerHTML = "Return Date";
	},

	_updateNationalityLabelCamper: function () {
		let drivingLicence = selectors.driverSectionCamper.getElementsByClassName('republic-country')[0].getElementsByClassName('republic-label')[0];
		drivingLicence.innerHTML = "Driving Licence";

		let nationalityLabel = selectors.driverSectionCamper.getElementsByClassName('republic-residence-country')[0].getElementsByClassName('republic-label')[0];
		nationalityLabel.innerHTML = "I Live In";

		//Handle small labels
		let nationalityLabelsmall = selectors.driverSectionCamper.getElementsByClassName('republic-residence-country')[0].getElementsByClassName('republic-small')[0];
		if (nationalityLabelsmall) {
			nationalityLabelsmall.innerHTML = "I Live In";
		}
	},

	_showForm: function () {
		formContainer.style.display = 'block';
	},

	_handleFormSubmission: function (formData) {
		// Initialize dataLayer if not exists
		window.dataLayer = window.dataLayer || [];

		// Push data to GTM
		dataLayer.push({ "event": "MotorhomeSubmission", "data": formData });

		// Dispatch custom DOM event for additional listeners
		const customEvent = new CustomEvent('campervanFormSubmission', {
			detail: {
				event: 'MotorhomeSubmission',
				data: formData
			},
			bubbles: true,
			cancelable: true
		});
		document.dispatchEvent(customEvent);
	},

	// Adding Tracking Code
	_datatag: function () {

		let formData = {
			Country: formContainer.querySelectorAll('.select2-selection__rendered')[0].innerText,
			PickUpLocation: formContainer.querySelectorAll('.select2-selection__rendered')[1].innerText,
			ReturnLocation: formContainer.querySelectorAll('.select2-selection__rendered')[2].innerText,
			DrivingLicence: formContainer.querySelectorAll('.select2-selection__rendered')[3].innerText,
			ILiveIn: formContainer.querySelectorAll('.select2-selection__rendered')[4].innerText,
			PickUpDate: formContainer.querySelectorAll('[name="start_date"]')[0].value,
			ReturnDate: formContainer.querySelectorAll('[name="end_date"]')[0].value,
			Age: formContainer.querySelectorAll('[name="age"]')[0].value,
			gtm: {
				uniqueEventId: (new Date().getTime() + new Date().getTimezoneOffset() * -60000).toString().substr(2, 10)
			}
		};

		// Check if running in iframe context
		if (window.parent && window.parent !== window) {
			// Send form data to parent window via postMessage
			const messageData = {
				type: 'motorhomeSubmission',
				formData: formData
			};
			window.parent.postMessage(messageData, window.location.origin);
		} else {
			// Not in iframe, push directly to dataLayer
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({ "event": "MotorhomeSubmission", "data": formData });
		}
	}
}

export { campervan };